import React from 'react';

class Page extends React.Component {
  render() {
    return (
      <div>
      </div>
    );
  }
}

export default Page;



/** WEBPACK FOOTER **
 ** ./src/components/contribute/page.js
 **/